import React, { ReactNode, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TranslationProvider } from './TranslationProvider/TranslationProvider';

const queryClient = new QueryClient();

export function Widget({ children, loader }: { children: ReactNode; loader: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => {
          const retry = () => {
            queryClient.refetchQueries().catch(console.error);
            resetErrorBoundary();
          };
          return (
            <div>
              <p>{error.message}</p>
              <button onClick={retry}>Retry</button>
            </div>
          );
        }}
      >
        <Suspense fallback={loader}>
          <TranslationProvider loader={loader}>{children}</TranslationProvider>
        </Suspense>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}
